// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb87fb91","455":"15e141b6"}[chunkId] + ".chunk.js";
};